class IntersectionObserverManager {
  constructor(options = {}) {
    this.options = {
      root: null,
      rootMargin: '-30% 0px 0px 0px',
      threshold: 0,
      targetSelector: '[data-observe]',
      visibleClass: 'is-visible',
      once: true, // 一度だけ発火するか
      ...options
    };
    
    this.observer = null;
    this.targets = [];
  }

  init() {
    this.targets = document.querySelectorAll(this.options.targetSelector);
    
    if (this.targets.length === 0) return;

    this.observer = new IntersectionObserver(
      this.handleIntersect.bind(this),
      {
        root: this.options.root,
        rootMargin: this.options.rootMargin,
        threshold: this.options.threshold
      }
    );

    this.targets.forEach(target => {
      this.observer.observe(target);
    });
  }

  handleIntersect(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add(this.options.visibleClass);
        // クラス付与を JS 側から拾えるようにする（GSAPタイムラインの起点）。
        // 購読側がいなければ何も起きないので、既存ページの挙動は変わらない
        entry.target.dispatchEvent(new CustomEvent('observe:visible', { bubbles: true }));
        
        if (this.options.once) {
          this.observer.unobserve(entry.target);
        }
      } else if (!this.options.once) {
        entry.target.classList.remove(this.options.visibleClass);
      }
    });
  }

  destroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}

const observerManager = new IntersectionObserverManager();

// ページ専用に別設定のインスタンスを作れるようクラスも公開する（既定のシングルトンは上のまま）
export { IntersectionObserverManager };
export default observerManager;
